import Link from "next/link";
import { Snackbar } from "@heathmont/moon-core-tw";
import BookmarkChecked from "../icons/BookmarkChecked";
import BookmarkXIcon from "../icons/BookmarkedX";

type SavedResourcesToastProps = {
  currentAction: SavedResourcesAction | null;
  isOpen: boolean;
  resourcePath: ResourcePath | null;
  handleClose: () => void;
};

export enum SavedResourcesAction {
  Add = "add",
  Remove = "remove",
}

export enum ResourcePath {
  ComponentSkill = "component-skills",
  Activity = "activities",
}

export const SavedResourcesToast = ({
  currentAction,
  isOpen,
  resourcePath,
  handleClose,
}: SavedResourcesToastProps) => {
  const toastMessage =
    currentAction === SavedResourcesAction.Add
      ? "Saved to your"
      : "Removed from your";
  return (
    <Snackbar
      isOpen={isOpen}
      position="bottom-center"
      onOpenChange={handleClose}
      autoClose={3000}
      className="max-w-sm rounded-xl border border-BG-60 bg-white p-4 pr-6 text-dark-color !shadow-[0_8px_8px_rgba(0,12,18,0.24)]"
    >
      <Snackbar.Icon className="aspect-auto h-8">
        {currentAction === SavedResourcesAction.Add ? (
          <BookmarkChecked />
        ) : (
          <BookmarkXIcon />
        )}
      </Snackbar.Icon>
      <Snackbar.Content>
        <p className="text-base">
          {toastMessage}{" "}
          <Link
            href={`/account/saved-resources/${resourcePath}`}
            shallow={true}
            className="font-semibold text-BG-60 underline"
          >
            resources
          </Link>
        </p>
      </Snackbar.Content>
    </Snackbar>
  );
};
